// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"79aaaa44","347":"a0140f26","472":"939d67dc","545":"602a14b4","583":"af1ed47c","620":"ce8997a8","634":"b2136272","786":"4c7bf2d5","854":"a7cc09ce","940":"2e4e299c","958":"3ea13e7c"}[chunkId] + ".chunk.js";
};